export default class Category {
    constructor(
        name,
        parentId,
        banner,
        image
    ) {
        this.name = name;
        this.parentId = parentId;
        this.banner = banner;
        this.image = image;
    }
}
